import {
  fromZonedTime,
  sanitizeExternalCalendarEvents,
  toZonedEventTimes,
} from '@griply/utils';
import { httpsCallable } from 'firebase/functions';
import { ExternalCalendarEvent } from 'shared/types/external-calendar-event';
import { Timestamp } from 'shared/types/timestamp';

import { getFunctions } from './helpers';

export type Options = {
  startDate: Timestamp;
  endDate: Timestamp;
  timezone: string;
};

export const getExternalCalendarEvents = async ({
  startDate,
  endDate,
  timezone,
}: Options) => {
  const functions = getFunctions();
  const fetchEvents = httpsCallable<
    { startDate: string; endDate: string; timezone: string },
    ExternalCalendarEvent[]
  >(functions, 'externalCalendars-getEvents');

  // The window arrives as the wall clock the grid shows — `timezone`'s — not as real instants.
  const { data } = await fetchEvents({
    startDate: fromZonedTime(startDate, timezone).toISOString(),
    endDate: fromZonedTime(endDate, timezone).toISOString(),
    timezone,
  });

  return sanitizeExternalCalendarEvents(data).map((event) =>
    toZonedEventTimes(event, timezone),
  );
};
